import commandsTemplate from './commands.html';

angular
   .module('org.saga.commands', ['org.saga.service'])

   .directive('screenCommands', [
      '$location',
      'InstanceExpression',
      function ($location, InstanceExpression) {
         return {
            restrict: 'E',
            controllerAs: 'ctrl',
            template: commandsTemplate,
            scope: {
               instance: '=',
               screen: '=',
               humantask: '=',
               onCommand: '&',
               primaryCommandDisabled: '&'
            },
            controller: [
               '$scope',
               '$mdDialog',
               '$translate',
               function ($scope, $mdDialog, $translate) {
                  $scope.icons = {
                     CLOSE: 'close',
                     COMPLETE: 'check',
                     EXIT: 'delete',
                     RELEASE: 'reply',
                     SAVE: 'save',
                     SUSPEND: 'pause',
                     UPDATE: 'backup',
                     //deprecated
                     DONE: 'check_circle'
                  };

                  $scope.primaryCommand = undefined;
                  $scope.allCommandsDisabled = false;

                  $scope.commands = [];

                  if ($scope.screen.commands) {
                     angular.forEach($scope.screen.commands, function (command) {
                        if ($scope.humantask && command.type === 'COMPLETE') {
                           $scope.primaryCommand = command;
                        } else if (!$scope.humantask && !$scope.primaryCommand) {
                           $scope.primaryCommand = command;
                        } else {
                           $scope.commands.push(command);
                        }
                     });
                  }

                  $scope.commandEnabled = (command) =>
                     !$scope.allCommandsDisabled &&
                     InstanceExpression.get(command.editable, $scope.instance, true);

                  $scope.go = function (command) {
                     if (command.type !== 'UPDATE') {
                        $scope.allCommandsDisabled = true;
                     }

                     if (command.confirmation) {
                        const confirm = $mdDialog
                           .confirm()
                           .title(command.confirmationMessage ?? $translate.instant('ConfirmAction'))
                           .ariaLabel('Update task data')
                           .ok($translate.instant('Yes'))
                           .cancel($translate.instant('Cancel'));

                        $mdDialog.show(confirm).then(
                           function () {
                              $scope.onCommand({ command: command });
                           },
                           function () {
                              $scope.allCommandsDisabled = false;
                           }
                        );
                     } else {
                        $scope.onCommand({ command: command });
                     }
                  };
               }
            ]
         };
      }
   ]);
